import type { FaireProductEntity } from "../../entity_types/product";

export const p_62hdwpdj3j: FaireProductEntity = {
  token: "p_62hdwpdj3j",
  type: "product",
  name: "Rustic Wooden Axe Toy",
  brandToken: "b_3q3fv8vc8q",
  brandName: "SIGMA STAR",
  imageUrl:
    "https://cdn.faire.com/fastly/2f3c6f8f72414d507f84437c71ebb5d8060393e32774b3a524daafdd330b64c8.jpeg",
  galleryImageUrls: [],
  priceDollars: 1.1,
  description:
    '\n Non-toxic wood, this toy axe ensures hours of safe and imaginative play for kids, allowing them to channel their inner warrior without any worries. 12" X 3.1.4"  -12 PCS PER CASE',
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:25.073Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
